<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
    components: {
        PageHeader,
        NextButton,
    },
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            channelName: '',
            wechatChannelAppId: '',
            wechatChannelSecret: '',
            wechatChannelToken: '',
            wechatChannelAesKey: '',
        };
    },
    computed: {
        ...mapGetters({
            uiFlags: 'inboxes/getUIFlags',
        }),
    },
    validations: {
        channelName: { required },
        wechatChannelAppId: { required },
        wechatChannelSecret: { required },
        wechatChannelToken: { required },
    },
    methods: {
        async createChannel() {
            this.v$.$touch();
            if (this.v$.$invalid) {
                return;
            }

            try {
                const channelData = {
                    name: this.channelName,
                    channel: {
                        type: 'wechat',
                        wechat_mp_channel_app_id: this.wechatChannelAppId,
                        wechat_mp_channel_secret: this.wechatChannelSecret,
                        wechat_mp_channel_token: this.wechatChannelToken,
                    },
                };

                if (this.wechatChannelAesKey) {
                    channelData.channel.aes_key = this.wechatChannelAesKey;
                }

                const wechatChannel = await this.$store.dispatch(
                    'inboxes/createChannel',
                    channelData
                );

                router.replace({
                    name: 'settings_inboxes_add_agents',
                    params: {
                        page: 'new',
                        inbox_id: wechatChannel.id,
                    },
                });
            } catch (error) {
                useAlert(this.$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.API.ERROR_MESSAGE'));
            }
        },
    },
};
</script>

<template>
    <div class="h-full w-full p-6 col-span-6">
        <PageHeader :header-title="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.TITLE')"
                    :header-content="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.DESC')" />
        <form class="flex flex-wrap flex-col mx-0"
              @submit.prevent="createChannel()">
            <div class="flex-shrink-0 flex-grow-0">
                <label :class="{ error: v$.channelName.$error }">
                    {{ $t('INBOX_MGMT.ADD.WECHAT_CHANNEL.CHANNEL_NAME.LABEL') }}
                    <input v-model="channelName"
                           type="text"
                           :placeholder="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
                            "
                           @blur="v$.channelName.$touch" />
                    <span v-if="v$.channelName.$error"
                          class="message">{{
                            $t('INBOX_MGMT.ADD.WECHAT_CHANNEL.CHANNEL_NAME.ERROR')
                        }}</span>
                </label>
            </div>

            <div class="flex-shrink-0 flex-grow-0">
                <label :class="{ error: v$.wechatChannelAppId.$error }">
                    {{ $t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_ID.LABEL') }}
                    <input v-model="wechatChannelAppId"
                           type="text"
                           :placeholder="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_ID.PLACEHOLDER')
                            "
                           @blur="v$.wechatChannelAppId.$touch" />
                </label>
            </div>

            <div class="flex-shrink-0 flex-grow-0">
                <label :class="{ error: v$.wechatChannelSecret.$error }">
                    {{ $t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_SECRET.LABEL') }}
                    <input v-model="wechatChannelSecret"
                           type="text"
                           :placeholder="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_SECRET.PLACEHOLDER')
                            "
                           @blur="v$.wechatChannelSecret.$touch" />
                </label>
            </div>

            <div class="flex-shrink-0 flex-grow-0">
                <label :class="{ error: v$.wechatChannelToken.$error }">
                    {{ $t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_TOKEN.LABEL') }}
                    <input v-model="wechatChannelToken"
                           type="text"
                           :placeholder="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_TOKEN.PLACEHOLDER')
                            "
                           @blur="v$.wechatChannelToken.$touch" />
                </label>
            </div>

            <div class="flex-shrink-0 flex-grow-0">
                <label>
                    {{ $t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_AES_KEY.LABEL') }}
                    <input v-model="wechatChannelAesKey"
                           type="text"
                           :placeholder="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.WECHAT_CHANNEL_AES_KEY.PLACEHOLDER')" />
                </label>
            </div>

            <div class="w-full mt-4">
                <NextButton :is-loading="uiFlags.isCreating"
                            type="submit"
                            solid
                            blue
                            :label="$t('INBOX_MGMT.ADD.WECHAT_CHANNEL.SUBMIT_BUTTON')" />
            </div>
        </form>
    </div>
</template>
